/**
 * `AuditRowPage` — Audit row detail page (/workspace/audit/row/:id)
 *
 * Shows detailed view of a specific audit row.
 */

import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AuditRowDetail } from '@/components/audit/AuditRowDetail';
import { EvidencePackPanel } from '@/components/audit/EvidencePackPanel';

export function AuditRowPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [evidencePackOpen, setEvidencePackOpen] = useState(false);

  if (!id) {
    return <div>Invalid audit row ID</div>;
  }

  const handleBackToList = () => {
    navigate('/workspace/audit');
  };

  const handleEvidencePackRequested = (_rowId: string) => {
    setEvidencePackOpen(true);
  };

  return (
    <div style={{ height: '100vh', overflow: 'auto' }}>
      <AuditRowDetail
        rowId={id}
        onBackToList={handleBackToList}
        onEvidencePackRequested={handleEvidencePackRequested}
      />
      
      <EvidencePackPanel
        isOpen={evidencePackOpen}
        onClose={() => setEvidencePackOpen(false)}
        rowId={id}
      />
    </div>
  );
}